import React, { Component } from 'react';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import AnnualSwitch from './AnnualSwitch';
import plans from './plans';

class SelectedPlan extends Component {
  constructor (props){
    super(props);
    
    this.toggleAnnual = this.toggleAnnual.bind(this);
    
    this.state = {
      annual: (this.props.plan || {}).annual || false
    }
  }
  
  toggleAnnual (){
    const {plan} = this.props
    this.props.onChange({...plan, annual: !plan.annual});
  }
  
  render() {
    const { plan: {id, annual}, onChange, withAnnualSwitch } = this.props;
    
    const plan = plans[id];
    const price = annual ? plan.annual_price : plan.price
    const BLACK_FRIDAY = window.BF2019_SALE;
    //{annual ? 'annual' : 'monthly'} 
    //const totalPriceSuffix = BLACK_FRIDAY && annual ? (`) : `per ${annual ? 'year' : 'month'}`;
    
    return (
      <div className="selected-pricing-plan">
        <div className="plan-name">{plan.name} Plan</div>
        
        {withAnnualSwitch && <AnnualSwitch onChange={this.toggleAnnual} checked={!annual} />}
        {annual && <div className="mb1 mt1"><span className="text-success float-right">-${((plan.price * 12) - plan.annual_price)}</span> {BLACK_FRIDAY ? 'Black Friday Savings' : 'Annual plan savings'}:</div>}
        {withAnnualSwitch && !annual && <div className="mb1 mt1 annual-benefits">Switch to annual and save <strong>${((plan.price * 12) - plan.annual_price)}</strong></div>}
        
        <div><strong>Total: </strong><span className="float-right text-right">${price} {BLACK_FRIDAY && annual ? (<React.Fragment>
          first year,<br /><span className="small gray">${plan.annual_then_price}/yr then</span>
        </React.Fragment>) :
          `per ${annual ? 'year' : 'month'}`
        }</span></div>
        { onChange && <Button color="link" size="sm" onClick={onChange}>Change Plan</Button> }
      </div>
    );
  }
}

export default SelectedPlan;


// WEBPACK FOOTER //
// ./src/components/billing/SelectedPlan.js